var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { faChevronDown, faChevronUp, faPlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BFormCheckbox, BFormGroup, BFormInput, BLink, BTab, BTabs } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { AUTO_EXTENSION, getUploadDatatypes } from "@/components/Upload/utils";
import { useConfig } from "@/composables/config";
import { useUserStore } from "@/stores/userStore";
import localize from "@/utils/localization";
import { orList } from "@/utils/strings";
import HelpText from "@/components/Help/HelpText.vue";
import DefaultBox from "@/components/Upload/DefaultBox.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionCreator',
    props: {
        oncancel: null,
        historyId: null,
        hideSourceItems: { type: Boolean },
        suggestedName: { default: "" },
        renderExtensionsToggle: { type: Boolean },
        extensions: { default: undefined },
        extensionsToggle: { type: Boolean, default: false },
        noItems: { type: Boolean },
        collectionType: null
    },
    emits: ["remove-extensions-toggle", "clicked-create", "onUpdateHideSourceItems", "on-update-datatype-toggle", "add-uploaded-files"],
    setup(__props, { emit }) {
        const props = __props;
        const Tabs = {
            create: 0,
            upload: 1,
        };
        const isExpanded = ref(false);
        const currentTab = ref(Tabs.create);
        const collectionName = ref(props.suggestedName);
        const localHideSourceItems = ref(props.hideSourceItems);
        const listExtensions = ref([]);
        const extensionsSet = ref(false);
        const validInput = computed(() => {
            return collectionName.value.length > 0;
        });
        // If there are props.extensions, filter the list of extensions to only include those
        const validExtensions = computed(() => {
            return listExtensions.value.filter((ext) => { var _a; return (_a = props.extensions) === null || _a === void 0 ? void 0 : _a.includes(ext.id); });
        });
        // Upload properties
        const { config, isConfigLoaded } = useConfig();
        const { currentUser } = storeToRefs(useUserStore());
        const configOptions = computed(() => isConfigLoaded.value
            ? {
                chunkUploadSize: config.value.chunk_upload_size,
                fileSourcesConfigured: config.value.file_sources_configured,
                ftpUploadSite: config.value.ftp_upload_site,
                defaultDbKey: config.value.default_genome || "",
                defaultExtension: config.value.default_extension || "",
            }
            : {});
        const ftpUploadSite = computed(() => currentUser.value && "id" in currentUser.value ? configOptions.value.ftpUploadSite : null);
        const defaultExtension = computed(() => {
            var _a;
            if (!configOptions.value || !extensionsSet.value) {
                return "auto";
            }
            else if (!((_a = props.extensions) === null || _a === void 0 ? void 0 : _a.length)) {
                return configOptions.value.defaultExtension || "auto";
            }
            else {
                return props.extensions[0];
            }
        });
        const shortWhatIsBeingCreated = computed(() => {
            // plain language for what is being created
            if (props.collectionType === "list") {
                return "list";
            }
            else if (props.collectionType === "list:paired") {
                return "list of pairs";
            }
            else if (props.collectionType == "paired") {
                return "dataset pair";
            }
            else {
                return "collection";
            }
        });
        function addUploadedFiles(value) {
            // TODO: We really need to wait for each of these items to get `state = 'ok'`
            //       before we can add them to the collection.
            emit("add-uploaded-files", value);
        }
        function clickForHelp() {
            isExpanded.value = !isExpanded.value;
            return isExpanded.value;
        }
        function cancelCreate() {
            props.oncancel();
        }
        function loadExtensions() {
            return __awaiter(this, void 0, void 0, function* () {
                listExtensions.value = yield getUploadDatatypes(false, AUTO_EXTENSION);
                extensionsSet.value = true;
            });
        }
        loadExtensions();
        watch(() => localHideSourceItems.value, () => {
            emit("onUpdateHideSourceItems", localHideSourceItems.value);
        });
        return { __sfc: true, Tabs, props, emit, isExpanded, currentTab, collectionName, localHideSourceItems, listExtensions, extensionsSet, validInput, validExtensions, config, isConfigLoaded, currentUser, configOptions, ftpUploadSite, defaultExtension, shortWhatIsBeingCreated, addUploadedFiles, clickForHelp, cancelCreate, loadExtensions, faChevronDown, faChevronUp, faPlus, faUpload, FontAwesomeIcon, BAlert, BButton, BFormCheckbox, BFormGroup, BFormInput, BLink, BTab, BTabs, localize, orList, HelpText, DefaultBox };
    }
});
